<template>
  <div class="main">
        <div class="admin-section">
            <b-form class="container" @submit="onSubmit" novalidate>
                <div class="row">
                    <h1 class="section-heading col-12">Edit numbers for counters</h1>
                </div>
                <b-overlay :show="loading">
                    <b-form-group label="Million tons of cargo:"
                                    label-for="cargo"
                                    invalid-feedback="A number greater that 0 should be passed."
                                    :state="cargoState">
                        <b-form-input id="cargo"
                                    v-model="numbers.cargo"
                                    :state="cargoState"
                                    type="number"
                                    trim></b-form-input>
                    </b-form-group>
                    <b-form-group label="Billion USD turn over:"
                                    label-for="turnover"
                                    invalid-feedback="A number greater that 0 should be passed."
                                    :state="turnoverState">
                        <b-form-input id="turnover"
                                    v-model="numbers.turnover"
                                    :state="turnoverState"
                                    type="number"
                                    trim></b-form-input>
                    </b-form-group>
                    <b-form-group label="Number of ships:"
                                    label-for="ships"
                                    invalid-feedback="A number greater that 0 should be passed."
                                    :state="shipsState">
                        <b-form-input id="ships"
                                    v-model="numbers.ships"
                                    :state="shipsState"
                                    type="number"
                                    trim></b-form-input>
                    </b-form-group>
                </b-overlay>
                <div class="buttons-container float-right">
                    <b-button @click="onCancel" class="cancel-button">Cancel changes</b-button>
                    <b-button type="submit" class="submit-button">Save changes</b-button>
                </div>
            </b-form>
        </div>
    </div>
</template>

<script>
import { doc, getDoc, updateDoc } from "firebase/firestore";
import { auth, db } from "../../firebase";

export default {
    name: "EditNumbers",
    data() {
        return  {
            loading: true,
            numbers: {
                cargo: undefined,
                turnover: undefined,
                ships: undefined
            },
            remote: {
                cargo: undefined,
                turnover: undefined,
                ships: undefined
            }
        }
    },
    computed: {
        cargoState() {
            return !!this.numbers.cargo && this.numbers.cargo > 0;
        },
        turnoverState() {
            return !!this.numbers.turnover && this.numbers.turnover > 0;
        },
        shipsState() {
            return !!this.numbers.ships && this.numbers.ships > 0;
        }
    },
    methods: {
        async onSubmit(e) {
            let numbers = this.numbers,
                remote =this.remote;

            e.preventDefault();

            if (!this.cargoState || !this.turnoverState || !this.shipsState) {
                alert("Numbers do not have proper values!");
                return;
            }

            if (remote.cargo === numbers.cargo && 
                remote.turnover === numbers.turnover && 
                remote.ships === numbers.ships) {
                    alert('There are no changes made.');
                    return;
            }

            if (this.docRef) {
                try {
                    this.loading = true;
                    numbers.cargo = Number(numbers.cargo);
                    numbers.turnover = Number(numbers.turnover);
                    numbers.ships = Number(numbers.ships);

                    await updateDoc(this.docRef, numbers);

                    this.remote.cargo = numbers.cargo;
                    this.remote.turnover = numbers.turnover;
                    this.remote.ships = numbers.ships;
                    alert("Numbers data successfully saved!");
                } catch {
                    alert("Update was not successful.");
                } finally {
                    this.loading = false;
                }
            } else {
                alert("Could not connect to database.");
            }
        },
        onCancel(e) {
            e.preventDefault();
            e.stopPropagation();

            this.getData();
        },
        async getData() {
            if (!this.docRef) {
                this.docRef = doc(db, "common", "numbers");
            }

            const docSnap = await getDoc(this.docRef);

            if (docSnap.exists()) {
                this.numbers.cargo = docSnap.data().cargo;
                this.numbers.turnover = docSnap.data().turnover;
                this.numbers.ships = docSnap.data().ships;
                this.remote.cargo = this.numbers.cargo;
                this.remote.turnover = this.numbers.turnover;
                this.remote.ships = this.numbers.ships;
                
                this.loading = false;
            } else {
                alert("Numbers data is not available.");
            }
        }
    },
    mounted() {
        if (!auth.currentUser) {
            this.$router.push('/admin');
        }

        this.getData();
    }
}
</script>